export default class DataModelBase {
    public id: string | undefined;
    [others: string]: any;
}
